module.exports = __webpack_public_path__ + "img/KZT.5919de67.png";